import { render, staticRenderFns } from "./userVeterinary.vue?vue&type=template&id=6071ea2e&"
import script from "./userVeterinary.vue?vue&type=script&lang=js&"
export * from "./userVeterinary.vue?vue&type=script&lang=js&"
import style0 from "./userVeterinary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports